<template>
  <div class="base-create-footer flex">
    <primary-button
      v-loading="primaryLoading"
      @click.native="handlePrimaryClick"
      id="continue-button"
    >
      {{ $t("common.save") }}
    </primary-button>
    <tertiary-button @click.native="handleCancelClick" class="ml-auto">
      {{ $t("common.cancel") }}
    </tertiary-button>
  </div>
</template>

<script>
import PrimaryButton from "@/components/common/buttons/PrimaryButton";
import TertiaryButton from "@/components/common/buttons/TertiaryButton";

import { identity } from "ramda";
export default {
  components: {
    PrimaryButton,
    TertiaryButton,
  },
  props: {
    title: String,
    primaryAction: {
      type: Function,
      default: identity,
    },
    primaryPreviousAction: {
      type: Function,
      default: identity,
    },
    primaryCancelAction: {
      type: Function,
      default: identity,
    },
    primaryActive: {
      type: Boolean,
      default: true,
    },
    cancelActive: {
      type: Boolean,
      default: false,
    },
    primaryPreviousActive: {
      type: Boolean,
      default: true,
    },
    primaryText: {
      type: String,
      default: "",
    },
    primaryTextShowIcon: {
      type: Boolean,
      default: true,
    },
    previousShowIcon: {
      type: Boolean,
      default: true,
    },
    primaryLoading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handlePrimaryClick() {
      this.primaryAction();
    },
    handleCancelClick() {
      this.primaryCancelAction();
    },
    handlePrimaryPreviousClick() {
      this.primaryPreviousAction();
    },
  },
};
</script>

<style lang="scss" scoped>
.base-create-header {
  h2 {
    font-weight: 800;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    color: #121131;
  }
}

.base-create-body {
  margin-top: 48px;
}

.base-create-footer {
  justify-content: center;
  button {
    height: 40px;
    font-size: 16px !important;
  }
}
.elsa-purple-button.el-button {
  padding: 10px 23px;
  margin-left: 20px !important;
  // width: 208px;
}
.el-button + .el-button {
  margin-left: 20px !important;
}

.ml-auto {
  margin-left: auto !important;
}

.elsa-flat-button.el-button {
  padding: 0;
  margin: 0;

  &:hover {
    background-color: transparent;
  }
}

#previous-button {
  min-width: 160px;
  &::v-deep span {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

#continue-button {
  min-width: 160px;
  &::v-deep span {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
